module.exports = __webpack_public_path__ + "static/media/iconCoursesActive.c137ba91.svg";